export default __webpack_public_path__ + "static/media/Responsive-Web-Design.319101a4.png";